// extracted by css-extract-rspack-plugin
export default {"cls1":"Shimmer-cls1_uGi","cls2":"Shimmer-cls2_DZB Shimmer-cls1_uGi","liswp-hero-shimmer":"Shimmer-liswp-hero-shimmer_01g"};